/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b82b01008b387d653b3db8d0cb216582>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const TagIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8.768 1.75H13c.69 0 1.25.56 1.25 1.25v4.232c0 .332-.132.65-.366.884l-5.75 5.75a1.25 1.25 0 0 1-1.768 0L2.134 9.634a1.25 1.25 0 0 1 0-1.768l5.75-5.75a1.25 1.25 0 0 1 .884-.366Z"/><rect width="2" height="2" x="10" y="4" fill="currentcolor" rx="1"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
TagIcon.displayName = 'TagIcon';
var _default = exports.default = TagIcon;